import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/core/assets/social/round-facebook.svg'
import _imports_1 from '@/core/assets/social/round-instagram.svg'


const _withScopeId = n => (_pushScopeId("data-v-5f871b70"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "body" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("section", { class: "header" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Facebook/Instagram Targeting"),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "fb-icon"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: "inst-icon"
  })
], -1))
const _hoisted_3 = { class: "data" }
const _hoisted_4 = { class: "data-header" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_targeting = _resolveComponent("targeting")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("section", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", {
          class: "targeting-type",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.selectTargetingType("detailed"))),
          style: _normalizeStyle({opacity: _ctx.activeTargetingType === "detailed" ? "1" : ".5"})
        }, " Detailed Targeting ", 4),
        _createElementVNode("div", {
          class: "targeting-type",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectTargetingType("regulated"))),
          style: _normalizeStyle({opacity: _ctx.activeTargetingType === "regulated" ? "1" : ".5"})
        }, " Regulated Targeting ", 4)
      ]),
      _createVNode(_component_targeting, { targetingType: _ctx.activeTargetingType }, null, 8, ["targetingType"])
    ])
  ]))
}